// extracted by mini-css-extract-plugin
module.exports = {"button":"AdsButton_button__2sato","appear":"AdsButton_appear__-FaIG"};